// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__2Offz","notes":"notes__aMmb5","row":"row__OYaor"};